'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('quickbooks-list', {
      url: '/user/balances',
      template: '<quickbooks-list></quickbooks-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/user/quickbooks-list/quickbooks-list.routes.js